module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a18"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The bell over the door jingled just as Emery Halloran stuck his head in the standing freezer in the back of the bakery.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He inwardly groaned. He’d forgotten to flip over the CLOSED sign and lock the door. Twisting his wrist to look at his watch, he caught the time. Ten after two. It was Wednesday, the sixth of December. He closed at two every Wednesday, which any locals of Sutter’s Bay would know, of course. Glad Tidings Bakery had been open for two years now. Emery had been idiotic enough to decide to open a bakery during the COVID pandemic. Somehow, he’d made it to his two-year anniversary.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Hello? Anyone here?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery closed the freezer, wiped his hands on the apron around his waist, and stepped through the swinging door into the front of the bakery.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Sorry, we’re closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("There was something familiar about the man standing just inside the entrance to Emery’s bakery. He was about three inches taller than six feet, Emery would guess, had big broad, muscular shoulders currently encased in a tailored dark blue suit jacket, and aviator sunglasses. He looked like someone’s idea of an FBI agent.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He had curly brown almost black hair and that was the part that seemed familiar to Emery. He couldn’t quite place the guy, though.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“We close at two on Wednesdays.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Hello, Emery.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("That voice. It was warm like honey.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery frowned. “Do I know you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Matthias Constantine.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He blinked, staring. “"), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Matty")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("There was just a slight uptick of the man’s lips that acknowledged the childhood nickname.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I go by Matthias now.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery wasn’t sure what to say to that, so he just stared at him. Overhead, Bing Crosby was crooning about a White Christmas, which seemed kind of ridiculous on a bright sunny day in Sutter’s Bay.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Uh, let me turn off the music track.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He went behind the counter and did just that, then removed the apron and came around to where Matthis stood waiting for God-knew-what.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“What the hell…er heck…are you doing in Sutter’s Bay? You don’t live here now, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery and Matthias had gone to school together, all through grade school, middle and high school. In Haydon Cliff, two hours away. And Emery hadn’t seen Matthias in years. Once they’d been close, even going so far as to share a few not so innocent kisses in high school, but those days were long gone.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Can we sit down?” Matthias glanced at the empty, rather rickety looking tables and chairs in the bakery. “Actually maybe we can grab a late lunch. I saw an open restaurant a few doors down.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Charlie’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yeah, that’s the one.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He didn’t mind Charlie’s. It was a casual middle-of-the-road type, kind of the sort Emery would go on dates. But this was no date, he reminded himself. Matthias Jones had gotten married and had two kids with his wife. At least. last Emery had heard.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But he couldn’t deny he was curious.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“All right.” He nodded. “Let me finish closing and we can head over there. We can walk there if your car’s near.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yes, in the parking lot of this strip mall.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Gotcha. I’ll be ready in a bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("They’d been seated and ordered before Emery asked once more why Matthias was in Sutter’s Bay.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery had ordered coffee and Charlie’s holiday time special of roast turkey with all the fixings. Matthias had ordered a burger and iced tea.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Why are you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Matthias smiled faintly. “One would get the impression you aren’t glad to see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He’d removed his sunglasses once they’d been seated so Emery had a very good look at his dark chocolate eyes. They were still as gorgeous and smoldering as they were when he’d last seen Matthias. What…ten years ago?")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery shook his head. “You seem to be evading the question.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Matthis sighed. “No, I still live in Haydon Cliff. I came here looking for you specifically.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Me? Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m an attorney now.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He said that as though that explained everything. It certainly didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I know. Well, I’d guessed. I knew you were going to law school. Heard you got married and have two kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Right. Your parents?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Mmm. When I was talking to them. Mom mostly. I didn’t talk to Dad once he disowned me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Water under the bridge. Emery had left Haydon Cliff after the estrangement from his parents. They’d had no other children, just him. At one time Eugene Halloran had been mayor. The Hallorans came from old money, so when his dad told Emery to leave, he’d disinherited him, too. But his mom had taken out a small insurance policy naming Emery the beneficiary so when their car had flown off a cliff not far from their home, Emery had enough money to open his bakery. It was the only evidence he’d ever received that Marjorie Halloran had not agreed entirely with her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m sorry about your folks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yeah. Well.” He shrugged. He didn’t want to seem callous, because of course he loved his parents and at one point they meant the world to them, but they had chosen not to have him in their life because of the “embarrassment.” And hearing about their accident had been a shock. His dad had always been a good driver. But there had been test results done after that indicated his father had too much to drink. “Me, too,” he finally said neutrally.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“So, your dad disowned you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“They both did,” Emery explained. He smiled at the waitress, who put his plate of roast turkey in front of him. “Thanks, Eleanor.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You want more coffee, honey?” she asked, pouring it for him without bothering to wait for his answer. She looked at Matthias. “Ketchup or Tabasco for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Ranch dressing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Coming right up.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery contemplated his coffee for a moment before adding another container of half and half. “I mean, Dad was the driving force, but she went along with it. Once they kicked me out of the house, I left Haydon Cliff. I talked to her maybe twice after that. Mostly to tell her where I was living, that kind of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Eleanor returned with the ranch dressing and plopped another iced tea down in front of Matthias before moving on to another table.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“When they were killed, I wasn’t surprised that Dad had left all his money to one of his favorite charities. But I was pretty surprised to get money from a separate life insurance policy from my mother. I was able to open Glad Tidings with that money. Forget about that. What’s with the visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Matthias had taken a bite of his burger, which he chewed and swallowed. “Besides being a lawyer, I’m also a private investigator.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yeah? Those things go hand in hand, do they?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He appeared amused. “They do for me. I specialize in estate law. Which is why I tracked you down.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Huh? Don’t tell me this is about Dad’s will. I already know I got nothing and I don’t want to fight it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“This isn’t about Mayor Halloran’s estate. This is about your uncle’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Uncle? What uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Specifically your great uncle. Sherman Halloran.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Emery snorted. “Dad’s uncle? He was estranged from my parents for years. I think the last time I saw him I was five years old. I thought he’d been dead for years.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“He’s alive, Emery. And living in Haydon Cliff.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“What?” He was honestly dumbfounded.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“And he wants to meet you.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7843c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0